import { Component, h } from '@stencil/core';
import uploadMegaMenuPath from '../../assets/header/lab-upload.svg';
import fontMegaMenuPath from '../../assets/header/lab-font.svg';
import houseMegaMenuPath from '../../assets/header/lab-clipart.svg';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-design-lab',
  styleUrl: 'ci-design-lab.scss',
  shadow: true,
})
export class ciDesignLab {
  render() {
    return (
      <div class="ciDesign-panel">
        <h1 class="ciDesign-lab-heading">
          The Design Lab Makes It Fun & Easy to Design
        </h1>
        <div class="ciDesign-lab-wrapper">
          <div class="ciDesign-lab-content">
            <p class="ciDesign-lab-content-description">Create custom t-shirts and promotional products your group will love. Simply upload your own logo or create a design using our collection of fonts & artwork.</p>
            <div class="ciDesign-lab-content-columns">
              <div class="ciDesign-lab-laptop"></div>
              <div class="ciDesign-lab-clipart">
                <div class="ciDesign-images">
                  <div>
                    <img class="ci-des" src={uploadMegaMenuPath} alt="art icon" />
                    <br />
                    <span class="sb-MMPLab-listItem-text">
                      Upload Your Own
                      <br />
                      Logo or Artwork
                    </span>
                  </div>
                  <div>
                    <img class="ci-des" src={fontMegaMenuPath} alt="font icon" />
                    <br />
                    <span class="sb-MMPLab-listItem-text">
                      Hundreds of <br />
                      Cool Fonts
                    </span>
                  </div>
                  <div>
                    <img class="ci-des" src={houseMegaMenuPath} alt="house icon" />
                    <br />
                    <span class="sb-MMPLab-listItem-text">
                      Incredible <br />
                      Artwork
                    </span>
                  </div>
                </div>
                <div class="ciDesign-lab-button">
                  <a
                    href={`${process.env.CI_HOSTNAME}/lab`}
                    data-section="design lab"
                    data-link="start designing"
                    onClick={trackAnalyticsEvent}
                  >
                    Start Designing
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="ciDesign-inspiration-content">
            <p class="ciDesign-inspiration-content-copy">Our customizable design templates make it easy to kickstart your idea.</p>
            <div class="ciDesign-inspiration-content-image"></div>
            <a
              href={`${process.env.CI_HOSTNAME}/inspiration`}
              data-section="explore templates"
              data-link="start designing"
              onClick={trackAnalyticsEvent}
            >
              Explore Templates
            </a>
          </div>
        </div>
      </div>
    );
  }
}
